// Angular modules
import { Component }                            from '@angular/core';
import { EventEmitter }                         from '@angular/core';
import { Input }                                from '@angular/core';
import { OnInit }                               from '@angular/core';
import { Output }                               from '@angular/core';
import { AbstractControl }                      from '@angular/forms';
import { FormControl }                          from '@angular/forms';
import { FormGroup }                            from '@angular/forms';

// Services
import { DynamicListFieldService }              from '../dynamic-list-filed.service';

// Models
import { Filter }                               from '../../../../../models/page.model';
import { FilterDynamicListSingleSelectOptions } from '../../filter-dynamic-list-single-select-options.model';

@Component({
  selector    : 'app-dynamic-list-field-single-select',
  templateUrl : './dynamic-list-field-single-select.component.html',
  styleUrls   : ['./dynamic-list-field-single-select.component.scss']
})
export class DynamicListFieldSingleSelectComponent implements OnInit
{
  dynamicListForm : FormGroup;
  dynamicList     : Array<any>;
  showLoader = true;

  @Input() data: FilterDynamicListSingleSelectOptions;

  @Output() dispatchFilterValue: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor(private dynamicListFieldService: DynamicListFieldService) {}

  ngOnInit()
  {
    this.dynamicListForm = new FormGroup({
      select: new FormControl('')
    });

    this.dynamicListFieldService.getDynamicList(this.data.url, this.data.sortMethod).subscribe(
      (list: Array<any>) => {
        this.dynamicList = list;
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  get select() : AbstractControl
  {
    return this.dynamicListForm.get('select');
  }

  onSelectionChange() : void
  {
    const filter: Filter = {};
    filter.value = this.select.value[this.data.filterBy];
    filter.label = this.select.value[this.data.labelToDisplay];
    filter.criteriaKey = this.data.criteriaKey;
    filter.criteriaLabel = this.data.criteriaLabel;
    this.dispatchFilterValue.emit(filter);
    this.dynamicListForm.reset();
  }
}
